import { configureStore } from "@reduxjs/toolkit";
import {
    Authentication,
    validateToken,
    PatientMenu,
    Appointments,
    RecheduleAppointment,
    AvailableSlotsForAppointment,
    AvailableDateForAppointment,
    ProxyUsers,
    Organization,
    Immunization,
    Diagonosis,
    PatientProfile,
    AllergyIntolerance,
    TreatmentOfChoice,
    Medication,
    NewMessages,
    PatientScreeningList,
    GetScreeningTemplateHTML,
    Messaging,
    LabResultsWithoutAttachment,
    LetterAndDocument,
    Timeline,
    Media,
    Observation,
    Location,
    GetMessageSubject,
    MessagingRecipients,
    MediaByID,
    MessageByID,
    PatientUpdate,
    Logout,
    StaffProfile,
    PatientAlerts,
    ChangePassword,
    ForgotPassword,
    UpdatePassword, gettingUpdatePasswordClear,
    LetterAndDocumentByID,
    LabResultByID,
} from "./actions";

const store = configureStore({
  middleware: getDefaultMiddleware =>
      getDefaultMiddleware({
          serializableCheck: false,
      }),
  reducer: {
    LetterAndDocumentByID,
    ForgotPassword,
    UpdatePassword,gettingUpdatePasswordClear,
    ChangePassword,
    PatientAlerts,
    StaffProfile,
    Logout,
    PatientUpdate,
    MessageByID,
    MediaByID,
    Location,
    MessagingRecipients,
    GetMessageSubject,
    Observation,
    Media,
    Timeline,
    LetterAndDocument,
    LabResultsWithoutAttachment,
    PatientScreeningList,
    GetScreeningTemplateHTML,
    Messaging,
    NewMessages,
    Medication,
    TreatmentOfChoice,
    AllergyIntolerance,
    Authentication,
    validateToken,
    PatientMenu,
    Appointments,
    RecheduleAppointment,
    AvailableSlotsForAppointment,
    AvailableDateForAppointment,
    ProxyUsers,
    Organization,
    Diagonosis,
    LabResultByID,
    Immunization,
    PatientProfile,
  }
})

export default store;
